var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { u as useQuery, d as distExports } from "./public-get.api-DzhvurPF.js";
import { M as MeasInfoHeaderTokenized } from "./tailwind-Cl-a6Nj3.js";
import { u as useLocalization, t as translatePassportTerm, d as buildMeasurementsTranslationPrefix, f as translateProductType, h as Loader, D as DEFAULT_LANGUAGE, a as LOCALIZATION_NAMESPACES, L as LocalizationProvider, B as BaseProvider } from "./base-provider-Br-ghcgu.js";
import { c as classNames } from "./index-V4C8gJtY.js";
import { useState, useRef, useEffect, useMemo } from "react";
import { g as getHiddenMeasurementsByMissingDefinitionDetails, a as getHiddenMeasurementsByTag, b as getHiddenMeasurementsByTagsPerClient, c as getHiddenMeasurementsByDefinitions, d as getDisplayableAdjustmentsInfoFromMeasurement, m as mapMeasurementsToAdjustments, e as getPassportScoreHint, f as getDisplayedFit, u as useTimeLocale, h as useDataDogMonitoringInitializer } from "./data-collectors-DFYYCeWL.js";
import { d as multiplyProductProfilesMeasurements, i as isCMClient, S as SizePassportScoreCode, c as isClientOffline } from "./use-circumference-measurements-query.hook-d3jyZ33a.js";
import { A as Accordion, T as Tooltip, a as TooltipTrigger, I as Icon, b as TooltipContent, c as TooltipDescription } from "./Tooltip-BBZEngpg.js";
import "react-dom";
import { a as formatDateRelative } from "./date-helper-BgT2-yhf.js";
import { q as queryProfilesPerProductTypes, a as queryCircumferenceMeasurementsPerProductTypes, b as queryMeasurementsPerProductTypes, d as useProfilesPreviewByAccountNrQuery } from "./use-profiles-by-account-nr-query.hooks-WQofLuhL.js";
import { u as useDataDogActionTracking, P as PassportClients } from "./common-BE7oYkqA.js";
import { M as MeasMissingParametersScreen } from "./meas-missing-parameters-screen-DDaVL6XA.js";
import { g as getEmptyPropsList } from "./entry-validators-Bjown2vt.js";
const SKELETON_DELAY_MS = 150;
const SKELETON_MIN_VISIBLE_MS = 400;
function useSkeletonPhase(isPending, options) {
  const startsVisible = isPending && Boolean(options == null ? void 0 : options.skipDelay);
  const [{
    hasShownSkeleton,
    phase
  }, setState] = useState(() => {
    if (!isPending) return {
      hasShownSkeleton: false,
      phase: "content"
    };
    return {
      hasShownSkeleton: startsVisible,
      phase: startsVisible ? "skeleton" : "reserve"
    };
  });
  const shownAtRef = useRef(0);
  useEffect(() => {
    if (isPending) {
      if (phase === "content") {
        shownAtRef.current = 0;
        setState({
          hasShownSkeleton: false,
          phase: "reserve"
        });
        return;
      }
      if (phase === "reserve") {
        const timer = window.setTimeout(() => {
          shownAtRef.current = Date.now();
          setState({
            hasShownSkeleton: true,
            phase: "skeleton"
          });
        }, SKELETON_DELAY_MS);
        return () => window.clearTimeout(timer);
      }
      if (shownAtRef.current === 0) {
        shownAtRef.current = Date.now();
      }
      return;
    }
    if (phase === "reserve") {
      setState((previous) => __spreadProps(__spreadValues({}, previous), {
        phase: "content"
      }));
      return;
    }
    if (phase === "skeleton") {
      const remaining = SKELETON_MIN_VISIBLE_MS - (Date.now() - shownAtRef.current);
      if (remaining <= 0) {
        setState((previous) => __spreadProps(__spreadValues({}, previous), {
          phase: "content"
        }));
        return;
      }
      const timer = window.setTimeout(() => setState((previous) => __spreadProps(__spreadValues({}, previous), {
        phase: "content"
      })), remaining);
      return () => window.clearTimeout(timer);
    }
  }, [isPending, phase]);
  return {
    phase,
    contentClassName: phase === "content" && hasShownSkeleton ? "motion-safe:animate-content-enter" : ""
  };
}
const CUSTOMER_PROFILES_FAILURE_EVENTS = {
  circumference: "meas-customer-profiles-circumference-failure",
  definitions: "meas-customer-profiles-definitions-failure",
  expand: "meas-customer-profiles-expand-failure",
  profiles: "meas-customer-profiles-load-failure"
};
function getFailedEndpointDetails({
  errors,
  eventNames
}) {
  const entries = [];
  if (errors.profilesError) {
    entries.push({
      eventName: eventNames.profiles,
      errorDetails: errors.profilesError
    });
  }
  if (errors.measurementsError) {
    entries.push({
      eventName: eventNames.definitions,
      errorDetails: errors.measurementsError
    });
  }
  if (errors.circumferenceError) {
    entries.push({
      eventName: eventNames.circumference,
      errorDetails: errors.circumferenceError
    });
  }
  return entries;
}
const SHIMMER_CLASSES = "motion-safe:after:content-[''] motion-safe:after:absolute motion-safe:after:top-0 motion-safe:after:left-0 motion-safe:after:h-full motion-safe:after:w-[30px] motion-safe:after:bg-surface motion-safe:after:blur-[25px] motion-safe:after:animate-skeleton-shimmer";
const toCssSize = (value) => {
  return typeof value === "number" ? `${value}px` : value;
};
function MeasSkeleton({
  w,
  h,
  r = 2,
  ar,
  className
}) {
  const style = {
    borderRadius: toCssSize(r)
  };
  if (w !== void 0) style.width = toCssSize(w);
  if (h !== void 0) style.height = toCssSize(h);
  if (ar !== void 0) style.aspectRatio = ar;
  return /* @__PURE__ */ jsx("div", { "aria-hidden": "true", className: classNames("relative overflow-hidden bg-surface-tertiary", SHIMMER_CLASSES, className), "data-testid": "skeleton", style });
}
function useCustomerPassportsData({
  accountNr,
  countryCode,
  isCircumferenceMappingEnabled,
  token
}) {
  var _a, _b;
  const isQueryEnabled = !!(accountNr && countryCode && token);
  const profilePerProductTypesQuery = useQuery(queryProfilesPerProductTypes({
    accountNr,
    countryCode,
    isEnabled: isQueryEnabled,
    token
  }));
  const productTypeIds = (_b = (_a = profilePerProductTypesQuery.data) == null ? void 0 : _a.map((g) => g.productTypeId)) != null ? _b : [];
  const isProductTypesAvailable = productTypeIds.length > 0;
  const circumferenceQuery = useQuery(queryCircumferenceMeasurementsPerProductTypes({
    isEnabled: isProductTypesAvailable && isCircumferenceMappingEnabled,
    productTypeIds
  }));
  const measurementsQuery = useQuery(queryMeasurementsPerProductTypes({
    countryCode,
    isEnabled: isProductTypesAvailable,
    productTypeIds
  }));
  const isLoading = profilePerProductTypesQuery.isLoading || circumferenceQuery.isLoading || measurementsQuery.isLoading;
  const isError = Boolean(profilePerProductTypesQuery.error) || Boolean(circumferenceQuery.error) || Boolean(measurementsQuery.error);
  const errors = useMemo(() => ({
    profilesError: profilePerProductTypesQuery.error,
    measurementsError: measurementsQuery.error,
    circumferenceError: circumferenceQuery.error
  }), [profilePerProductTypesQuery.error, measurementsQuery.error, circumferenceQuery.error]);
  const data = useMemo(() => {
    var _a2, _b2, _c;
    return {
      profilePerProductType: (_a2 = profilePerProductTypesQuery.data) != null ? _a2 : [],
      circumferencePerProductType: (_b2 = circumferenceQuery.data) != null ? _b2 : [],
      measurementsPerProductType: (_c = measurementsQuery.data) != null ? _c : []
    };
  }, [profilePerProductTypesQuery.data, circumferenceQuery.data, measurementsQuery.data]);
  return {
    isLoading,
    isError,
    errors,
    data
  };
}
const mapCustomerProfileData = ({
  circumferencePerProductType,
  isCircumferenceMappingEnabled,
  measurementsPerProductType,
  profilePerProductType
}) => {
  return profilePerProductType.filter((item) => item.profile !== null).map((item, index) => {
    var _a, _b, _c, _d;
    const circumferenceIds = isCircumferenceMappingEnabled ? (_b = (_a = circumferencePerProductType.find((entry) => entry.productTypeId === item.productTypeId)) == null ? void 0 : _a.circumferenceMeasurements) != null ? _b : [] : [];
    const profile = circumferenceIds.length > 0 ? multiplyProductProfilesMeasurements(circumferenceIds, [item.profile])[0] : item.profile;
    const definitions = (_d = (_c = measurementsPerProductType.find((entry) => entry.productTypeId === item.productTypeId)) == null ? void 0 : _c.measurements) != null ? _d : [];
    return {
      circumferenceMeasurementIds: circumferenceIds,
      definitions,
      productTypeId: item.productTypeId,
      profile,
      profilesCount: item.profilesCount,
      sequenceNo: index,
      title: item.productTypeId
    };
  });
};
const splitProfileMeasurements = (profile, measurementDefinitions) => {
  const isCmProfile = isCMClient(profile.sizePassport.source);
  const hiddenMeasurementsByCMDetails = isCmProfile ? getHiddenMeasurementsByMissingDefinitionDetails(measurementDefinitions) : [];
  const hiddenMeasurementsByTag = getHiddenMeasurementsByTag(measurementDefinitions, getHiddenMeasurementsByTagsPerClient(profile.sizePassport.source, profile.productTypeId));
  const hiddenMeasurements = /* @__PURE__ */ new Set([...hiddenMeasurementsByCMDetails, ...hiddenMeasurementsByTag]);
  const profileMeasurements = profile.sizePassport.measurementValues || [];
  const profileMeasurementsFiltered = profileMeasurements.length && measurementDefinitions.length && hiddenMeasurements.size ? profileMeasurements.filter((measurement) => !hiddenMeasurements.has(measurement.measurementId)) : profileMeasurements;
  const notAlterableAndToleratedMeasurements = new Set(isCmProfile ? [] : getHiddenMeasurementsByDefinitions(measurementDefinitions, profileMeasurementsFiltered));
  if (!notAlterableAndToleratedMeasurements.size) {
    return {
      applicable: profileMeasurementsFiltered,
      applicableInCustomMade: []
    };
  }
  return {
    applicable: profileMeasurementsFiltered.filter((measurement) => !notAlterableAndToleratedMeasurements.has(measurement.measurementId)),
    applicableInCustomMade: profileMeasurementsFiltered.filter((measurement) => notAlterableAndToleratedMeasurements.has(measurement.measurementId))
  };
};
const formatAlterationValue = (value) => {
  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) {
    return value;
  }
  if (Number.isInteger(numericValue)) {
    return value.startsWith("+") ? `+${numericValue.toFixed(1)}` : numericValue.toFixed(1);
  }
  return value;
};
const SCORE_TONE_CLASSES = {
  [SizePassportScoreCode.SAFE]: "bg-surface-success text-text-success",
  [SizePassportScoreCode.WARNING]: "bg-surface-warning text-text-warning",
  [SizePassportScoreCode.RISK]: "bg-surface-error text-text-error"
};
const getScoreToneClass = (score) => {
  var _a;
  return (_a = SCORE_TONE_CLASSES[score.scoreCode]) != null ? _a : SCORE_TONE_CLASSES[SizePassportScoreCode.RISK];
};
const getAdjustmentsTitle = ({
  adjustmentsLength,
  isSelfExpandable,
  isVisible,
  t,
  titleOverride,
  titlePlaceholder
}) => {
  if (titleOverride) {
    return titleOverride;
  }
  if (!isVisible && !isSelfExpandable) {
    return titlePlaceholder != null ? titlePlaceholder : t("shared.cardAdjustments.titlePlaceholder");
  }
  if (adjustmentsLength === 0) {
    return t("shared.cardAdjustments.titleNone");
  }
  if (adjustmentsLength === 1) {
    return t("shared.cardAdjustments.titleOne");
  }
  return t("shared.cardAdjustments.title", {
    count: `${adjustmentsLength}`
  });
};
function CustomerProfileCardSkeleton() {
  "use memo";
  const $ = distExports.c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /* @__PURE__ */ jsx("div", { className: "flex h-20 items-center", children: /* @__PURE__ */ jsx(MeasSkeleton, { h: 14, w: 96 }) });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /* @__PURE__ */ jsx(MeasSkeleton, { h: 16, w: 88 });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ jsx(MeasSkeleton, { h: 12, w: 52 }),
      /* @__PURE__ */ jsx(MeasSkeleton, { h: 12, w: 132 })
    ] });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ jsx(MeasSkeleton, { h: 12, w: 32 }),
      /* @__PURE__ */ jsx(MeasSkeleton, { h: 12, w: 164 })
    ] });
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-10", children: [
      t1,
      t2,
      t3,
      /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx(MeasSkeleton, { h: 12, w: 60 }),
        /* @__PURE__ */ jsx(MeasSkeleton, { h: 12, w: 188 })
      ] })
    ] });
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = /* @__PURE__ */ jsxs("div", { className: "flex flex-col", "data-testid": "customer-profile-card-skeleton", children: [
      t0,
      /* @__PURE__ */ jsxs("div", { className: "mt-14 flex flex-col gap-16 rounded-lg border border-border bg-surface p-20", children: [
        t4,
        /* @__PURE__ */ jsx("div", { className: "border-t border-border pt-10", children: /* @__PURE__ */ jsx(MeasSkeleton, { h: 14, w: 112 }) })
      ] })
    ] });
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function AdjustmentRow({
  measurement,
  productTypeId,
  unit
}) {
  const t = useLocalization();
  const {
    alterationValue,
    isAdjustmentIncreasing,
    isAdjustmentDecreasing
  } = getDisplayableAdjustmentsInfoFromMeasurement(measurement);
  const formattedAlterationValue = formatAlterationValue(alterationValue);
  return /* @__PURE__ */ jsxs("div", { className: "flex w-full flex-row items-start justify-between gap-4 text-sm leading-sm font-light", children: [
    /* @__PURE__ */ jsx("span", { className: "min-w-0 shrink text-text", children: translatePassportTerm({
      prefix: buildMeasurementsTranslationPrefix(productTypeId),
      t,
      term: measurement.description
    }) }),
    /* @__PURE__ */ jsx("div", { className: "flex shrink-0 items-center gap-8 text-right", children: measurement.defaultValue !== 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("span", { className: classNames({
        "text-text-success": isAdjustmentIncreasing,
        "text-text-error": isAdjustmentDecreasing,
        "text-text": !isAdjustmentIncreasing && !isAdjustmentDecreasing
      }), children: formattedAlterationValue }),
      /* @__PURE__ */ jsxs("span", { className: "text-text", children: [
        "(",
        measurement.value,
        " ",
        unit,
        ")"
      ] })
    ] }) : /* @__PURE__ */ jsxs("span", { className: "text-text", children: [
      "(",
      formattedAlterationValue,
      " ",
      unit,
      ")"
    ] }) })
  ] });
}
function CustomerProfileAdjustmentsList({
  measurements,
  productTypeId,
  unitValue
}) {
  if (!measurements.length) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: "flex w-full flex-col gap-4 pr-4", children: measurements.map((measurement) => /* @__PURE__ */ jsx(AdjustmentRow, { measurement, productTypeId, unit: unitValue }, measurement.measurementId)) });
}
const NO_MEASUREMENTS = [];
function CustomerProfileAdjustmentsSection(t0) {
  "use memo";
  const $ = distExports.c(40);
  const {
    customMadeMeasurements: t1,
    isSelfExpandable: t2,
    isVisible: t3,
    measurements,
    productTypeId,
    titleOverride,
    titlePlaceholder,
    unitValue
  } = t0;
  const customMadeMeasurements = t1 === void 0 ? NO_MEASUREMENTS : t1;
  const isSelfExpandable = t2 === void 0 ? false : t2;
  const isVisible = t3 === void 0 ? false : t3;
  const t = useLocalization();
  let adjustments;
  let customMadeAdjustments;
  let isAdjustmentsAvailable;
  let isCustomMadeAvailable;
  let t4;
  if ($[0] !== customMadeMeasurements || $[1] !== isSelfExpandable || $[2] !== isVisible || $[3] !== measurements || $[4] !== t || $[5] !== titleOverride || $[6] !== titlePlaceholder) {
    adjustments = mapMeasurementsToAdjustments(measurements);
    let t52;
    if ($[12] !== customMadeMeasurements) {
      t52 = mapMeasurementsToAdjustments(customMadeMeasurements);
      $[12] = customMadeMeasurements;
      $[13] = t52;
    } else {
      t52 = $[13];
    }
    customMadeAdjustments = t52;
    isAdjustmentsAvailable = adjustments.length > 0;
    isCustomMadeAvailable = customMadeAdjustments.length > 0;
    t4 = getAdjustmentsTitle({
      adjustmentsLength: adjustments.length,
      isSelfExpandable,
      isVisible,
      t,
      titleOverride,
      titlePlaceholder
    });
    $[0] = customMadeMeasurements;
    $[1] = isSelfExpandable;
    $[2] = isVisible;
    $[3] = measurements;
    $[4] = t;
    $[5] = titleOverride;
    $[6] = titlePlaceholder;
    $[7] = adjustments;
    $[8] = customMadeAdjustments;
    $[9] = isAdjustmentsAvailable;
    $[10] = isCustomMadeAvailable;
    $[11] = t4;
  } else {
    adjustments = $[7];
    customMadeAdjustments = $[8];
    isAdjustmentsAvailable = $[9];
    isCustomMadeAvailable = $[10];
    t4 = $[11];
  }
  const combinedTitle = t4;
  if (isSelfExpandable && (isAdjustmentsAvailable || isCustomMadeAvailable)) {
    let t52;
    if ($[14] !== adjustments || $[15] !== productTypeId || $[16] !== unitValue) {
      t52 = /* @__PURE__ */ jsx(CustomerProfileAdjustmentsList, { measurements: adjustments, productTypeId, unitValue });
      $[14] = adjustments;
      $[15] = productTypeId;
      $[16] = unitValue;
      $[17] = t52;
    } else {
      t52 = $[17];
    }
    let t62;
    if ($[18] !== customMadeAdjustments || $[19] !== isCustomMadeAvailable || $[20] !== productTypeId || $[21] !== t || $[22] !== unitValue) {
      t62 = isCustomMadeAvailable ? /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-10 pt-16", children: [
        /* @__PURE__ */ jsx("p", { className: "text-sm leading-sm font-medium text-text", children: t("shared.cardAdjustments.titleApplicableInCustomMade") }),
        /* @__PURE__ */ jsx(CustomerProfileAdjustmentsList, { measurements: customMadeAdjustments, productTypeId, unitValue })
      ] }) : null;
      $[18] = customMadeAdjustments;
      $[19] = isCustomMadeAvailable;
      $[20] = productTypeId;
      $[21] = t;
      $[22] = unitValue;
      $[23] = t62;
    } else {
      t62 = $[23];
    }
    let t72;
    if ($[24] !== combinedTitle || $[25] !== isVisible || $[26] !== t52 || $[27] !== t62) {
      t72 = /* @__PURE__ */ jsx("div", { className: "flex w-full flex-col gap-10", children: /* @__PURE__ */ jsxs(Accordion, { className: "border-none font-medium", defaultOpen: isVisible, headerClassName: "font-medium text-text [&:hover]:text-text", title: combinedTitle, children: [
        t52,
        t62
      ] }) });
      $[24] = combinedTitle;
      $[25] = isVisible;
      $[26] = t52;
      $[27] = t62;
      $[28] = t72;
    } else {
      t72 = $[28];
    }
    return t72;
  }
  let t5;
  if ($[29] !== combinedTitle) {
    t5 = /* @__PURE__ */ jsx("p", { className: "text-sm leading-sm font-medium text-text", children: combinedTitle });
    $[29] = combinedTitle;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  let t6;
  if ($[31] !== adjustments || $[32] !== isAdjustmentsAvailable || $[33] !== isVisible || $[34] !== productTypeId || $[35] !== unitValue) {
    t6 = isAdjustmentsAvailable && isVisible ? /* @__PURE__ */ jsx(CustomerProfileAdjustmentsList, { measurements: adjustments, productTypeId, unitValue }) : null;
    $[31] = adjustments;
    $[32] = isAdjustmentsAvailable;
    $[33] = isVisible;
    $[34] = productTypeId;
    $[35] = unitValue;
    $[36] = t6;
  } else {
    t6 = $[36];
  }
  let t7;
  if ($[37] !== t5 || $[38] !== t6) {
    t7 = /* @__PURE__ */ jsxs("div", { className: "flex w-full flex-col gap-10", children: [
      t5,
      t6
    ] });
    $[37] = t5;
    $[38] = t6;
    $[39] = t7;
  } else {
    t7 = $[39];
  }
  return t7;
}
function CustomerProfileScoreHint({
  score
}) {
  const t = useLocalization();
  const hint = getPassportScoreHint({
    score,
    t
  });
  if (!hint) return null;
  return /* @__PURE__ */ jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: /* @__PURE__ */ jsx("button", { "aria-label": t("shared.profilesOverview.scoreInfoAriaLabel"), className: `flex size-16 items-center justify-center rounded-full ${getScoreToneClass(score)}`, "data-testid": "customer-profile-score-hint", type: "button", children: /* @__PURE__ */ jsx(Icon, { color: "current", name: "info", size: 14 }) }) }),
    /* @__PURE__ */ jsx(TooltipContent, { align: "start", portal: false, children: /* @__PURE__ */ jsx(TooltipDescription, { children: hint }) })
  ] });
}
function CustomerProfileCard(t0) {
  "use memo";
  const $ = distExports.c(61);
  const {
    client,
    measurementDefinitions,
    profile
  } = t0;
  const t = useLocalization();
  let t1;
  if ($[0] !== measurementDefinitions || $[1] !== profile) {
    t1 = splitProfileMeasurements(profile, measurementDefinitions);
    $[0] = measurementDefinitions;
    $[1] = profile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    applicable,
    applicableInCustomMade
  } = t1;
  let t2;
  if ($[3] !== applicableInCustomMade || $[4] !== client) {
    t2 = isClientOffline(client) ? applicableInCustomMade : void 0;
    $[3] = applicableInCustomMade;
    $[4] = client;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const customMadeMeasurements = t2;
  let t3;
  if ($[6] !== profile || $[7] !== t) {
    t3 = getDisplayedFit(profile, t);
    $[6] = profile;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const displayedFit = t3;
  const {
    creationDate,
    displaySize,
    score,
    storeLocationName
  } = profile.sizePassport;
  let t4;
  if ($[9] !== displaySize || $[10] !== t) {
    t4 = t("shared.card.sizeLabel", {
      size: displaySize
    });
    $[9] = displaySize;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = /* @__PURE__ */ jsx("h3", { className: "text-base leading-base font-medium text-text", children: t4 });
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== score) {
    t6 = score ? /* @__PURE__ */ jsx(CustomerProfileScoreHint, { score }) : null;
    $[14] = score;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = /* @__PURE__ */ jsxs("div", { className: "flex flex-row flex-wrap items-center gap-8", children: [
      t5,
      t6
    ] });
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t) {
    t8 = t("shared.card.nameLabel");
    $[19] = t;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t8) {
    t9 = /* @__PURE__ */ jsx("span", { className: "shrink-0 text-text", children: t8 });
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== profile.name) {
    t10 = /* @__PURE__ */ jsx("span", { className: "min-w-0 truncate", children: profile.name });
    $[23] = profile.name;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t9) {
    t11 = /* @__PURE__ */ jsxs("div", { className: "flex min-w-0 flex-3 flex-row flex-wrap items-center justify-between gap-4", children: [
      t9,
      t10
    ] });
    $[25] = t10;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== displayedFit || $[29] !== t) {
    t12 = displayedFit ? /* @__PURE__ */ jsxs("div", { className: "flex min-w-0 flex-3 flex-row flex-wrap items-center justify-between gap-4", children: [
      /* @__PURE__ */ jsx("span", { className: "shrink-0 text-text", children: t("shared.card.fitLabel") }),
      /* @__PURE__ */ jsx("span", { className: "min-w-0 truncate text-right", children: displayedFit })
    ] }) : null;
    $[28] = displayedFit;
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t) {
    t13 = t("shared.card.createdLabel");
    $[31] = t;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t13) {
    t14 = /* @__PURE__ */ jsx("span", { className: "shrink-0 text-text", children: t13 });
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const t15 = storeLocationName ? `${storeLocationName}, ` : "";
  let t16;
  if ($[35] !== creationDate || $[36] !== t) {
    t16 = formatDateRelative(creationDate, t);
    $[35] = creationDate;
    $[36] = t;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t15 || $[39] !== t16) {
    t17 = /* @__PURE__ */ jsxs("span", { className: "min-w-0 truncate", children: [
      t15,
      t16
    ] });
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t14 || $[42] !== t17) {
    t18 = /* @__PURE__ */ jsxs("div", { className: "flex min-w-0 flex-3 flex-row flex-wrap items-center justify-between gap-4", children: [
      t14,
      t17
    ] });
    $[41] = t14;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t11 || $[45] !== t12 || $[46] !== t18) {
    t19 = /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-[2px] pt-[2px] text-sm leading-sm font-light text-text", children: [
      t11,
      t12,
      t18
    ] });
    $[44] = t11;
    $[45] = t12;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== t19 || $[49] !== t7) {
    t20 = /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2", children: [
      t7,
      t19
    ] });
    $[48] = t19;
    $[49] = t7;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  const t21 = profile.productTypeId;
  let t22;
  if ($[51] !== t) {
    t22 = t("shared.unitSymbol.cm");
    $[51] = t;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== applicable || $[54] !== customMadeMeasurements || $[55] !== profile.productTypeId || $[56] !== t22) {
    t23 = /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-16 border-t border-border pt-10", children: /* @__PURE__ */ jsx(CustomerProfileAdjustmentsSection, { isSelfExpandable: true, customMadeMeasurements, isVisible: false, measurements: applicable, productTypeId: t21, unitValue: t22 }) });
    $[53] = applicable;
    $[54] = customMadeMeasurements;
    $[55] = profile.productTypeId;
    $[56] = t22;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== t20 || $[59] !== t23) {
    t24 = /* @__PURE__ */ jsxs("article", { className: "flex flex-col gap-16 rounded-lg border border-border bg-surface p-20", children: [
      t20,
      t23
    ] });
    $[58] = t20;
    $[59] = t23;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  return t24;
}
function CustomerProfileListFooterControl({
  isHiddenWhenDisabled,
  isDisabled,
  isExpanded,
  showMoreText,
  onToggle
}) {
  const t = useLocalization();
  if (isHiddenWhenDisabled && isDisabled) {
    return null;
  }
  const label = isExpanded ? t("shared.productProfilesFooter.showLess") : showMoreText;
  return /* @__PURE__ */ jsx("div", { className: "mt-16 flex justify-center", children: /* @__PURE__ */ jsxs("button", { className: "flex cursor-pointer items-center gap-8 text-sm leading-sm font-light text-text transition-[color] hover:text-text-secondary", type: "button", onClick: onToggle, children: [
    /* @__PURE__ */ jsx(Icon, { color: "default", name: isExpanded ? "chevron-up" : "chevron-down", size: "medium" }),
    label
  ] }) });
}
function ListHeading({
  productTitle
}) {
  return /* @__PURE__ */ jsx("h2", { className: "text-sm leading-sm font-medium text-text", children: productTitle });
}
function LoadingBlock() {
  const t = useLocalization();
  return /* @__PURE__ */ jsx("div", { className: "flex min-h-80 flex-col items-center justify-center gap-16 px-16 py-32", children: /* @__PURE__ */ jsx("div", { className: "h-24 w-80 text-text", children: /* @__PURE__ */ jsx(Loader, { ariaLabel: t("shared.profilesOverview.loadingLabel") }) }) });
}
function CustomerProfileList(t0) {
  "use memo";
  const $ = distExports.c(52);
  const {
    accountNr,
    circumferenceMeasurementIds,
    client,
    countryCode,
    definitions,
    productTypeId,
    profile,
    profilesCount,
    title,
    token
  } = t0;
  const t = useLocalization();
  const {
    trackAction
  } = useDataDogActionTracking();
  const hasMoreProfiles = profilesCount > 1;
  const [isFetchTriggered, setIsFetchTriggered] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  let t1;
  if ($[0] !== accountNr || $[1] !== circumferenceMeasurementIds || $[2] !== countryCode || $[3] !== isFetchTriggered || $[4] !== productTypeId || $[5] !== token) {
    t1 = {
      accountNr,
      circumferenceMeasurementIds,
      countryCode,
      isEnabled: isFetchTriggered,
      productType: productTypeId,
      token
    };
    $[0] = accountNr;
    $[1] = circumferenceMeasurementIds;
    $[2] = countryCode;
    $[3] = isFetchTriggered;
    $[4] = productTypeId;
    $[5] = token;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    error: allProfilesError,
    isLoading: isLoadingAllProfiles,
    isSuccess: isSuccessAllProfiles,
    profiles: allProfiles,
    refetch: refetchAllProfiles
  } = useProfilesPreviewByAccountNrQuery(t1);
  let t2;
  let t3;
  if ($[7] !== accountNr || $[8] !== allProfilesError || $[9] !== client || $[10] !== countryCode || $[11] !== productTypeId || $[12] !== trackAction) {
    t2 = () => {
      if (!allProfilesError) {
        return;
      }
      trackAction({
        eventName: CUSTOMER_PROFILES_FAILURE_EVENTS.expand,
        eventDetails: {
          accountNr,
          client,
          countryCode,
          errorDetails: allProfilesError,
          productTypeId
        },
        eventType: "error"
      });
    };
    t3 = [allProfilesError, accountNr, client, countryCode, productTypeId, trackAction];
    $[7] = accountNr;
    $[8] = allProfilesError;
    $[9] = client;
    $[10] = countryCode;
    $[11] = productTypeId;
    $[12] = trackAction;
    $[13] = t2;
    $[14] = t3;
  } else {
    t2 = $[13];
    t3 = $[14];
  }
  useEffect(t2, t3);
  let t4;
  if ($[15] !== refetchAllProfiles) {
    t4 = () => {
      refetchAllProfiles();
    };
    $[15] = refetchAllProfiles;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const handleRetry = t4;
  let t5;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsFetchTriggered(true);
      setIsExpanded(_temp);
    };
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const handleToggle = t5;
  let t6;
  if ($[18] !== allProfiles || $[19] !== isExpanded || $[20] !== isSuccessAllProfiles || $[21] !== profile) {
    t6 = isExpanded && isSuccessAllProfiles ? [profile, ...allProfiles.filter((entry) => entry.id !== profile.id)] : [profile];
    $[18] = allProfiles;
    $[19] = isExpanded;
    $[20] = isSuccessAllProfiles;
    $[21] = profile;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  const profilesList = t6;
  let t7;
  if ($[23] !== t || $[24] !== title) {
    t7 = translateProductType({
      productTypeId: title,
      t
    });
    $[23] = t;
    $[24] = title;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t7) {
    t8 = /* @__PURE__ */ jsx(ListHeading, { productTitle: t7 });
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== client || $[29] !== definitions || $[30] !== profilesList) {
    t9 = /* @__PURE__ */ jsx("div", { className: "mt-14 flex flex-col gap-32", children: profilesList.map((entry_0) => /* @__PURE__ */ jsx(CustomerProfileCard, { client, measurementDefinitions: definitions, profile: entry_0 }, entry_0.id)) });
    $[28] = client;
    $[29] = definitions;
    $[30] = profilesList;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== isLoadingAllProfiles) {
    t10 = isLoadingAllProfiles && /* @__PURE__ */ jsx(LoadingBlock, {});
    $[32] = isLoadingAllProfiles;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== allProfilesError || $[35] !== handleRetry || $[36] !== productTypeId || $[37] !== t) {
    t11 = allProfilesError && /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center gap-12 rounded-md border border-border bg-surface px-16 py-24", children: [
      /* @__PURE__ */ jsx("p", { className: "text-center text-sm leading-sm text-text", children: t("shared.profilesOverview.loadProfilesError", {
        productType: translateProductType({
          productTypeId,
          t
        })
      }) }),
      /* @__PURE__ */ jsx("button", { className: "text-sm leading-sm font-medium text-text underline transition-[color] hover:text-text-secondary", type: "button", onClick: handleRetry, children: t("shared.errorHint.retryBtnLabel") })
    ] });
    $[34] = allProfilesError;
    $[35] = handleRetry;
    $[36] = productTypeId;
    $[37] = t;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== allProfilesError || $[40] !== hasMoreProfiles || $[41] !== isExpanded || $[42] !== isLoadingAllProfiles || $[43] !== isSuccessAllProfiles || $[44] !== t) {
    t12 = hasMoreProfiles && !allProfilesError && /* @__PURE__ */ jsx(CustomerProfileListFooterControl, { isHiddenWhenDisabled: true, isDisabled: isLoadingAllProfiles, isExpanded: isExpanded && isSuccessAllProfiles, showMoreText: t("shared.profilesOverview.showAllBtnLabel"), onToggle: handleToggle });
    $[39] = allProfilesError;
    $[40] = hasMoreProfiles;
    $[41] = isExpanded;
    $[42] = isLoadingAllProfiles;
    $[43] = isSuccessAllProfiles;
    $[44] = t;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  let t13;
  if ($[46] !== t10 || $[47] !== t11 || $[48] !== t12 || $[49] !== t8 || $[50] !== t9) {
    t13 = /* @__PURE__ */ jsxs("div", { className: "flex flex-col bg-background", children: [
      t8,
      t9,
      t10,
      t11,
      t12
    ] });
    $[46] = t10;
    $[47] = t11;
    $[48] = t12;
    $[49] = t8;
    $[50] = t9;
    $[51] = t13;
  } else {
    t13 = $[51];
  }
  return t13;
}
function _temp(previous) {
  return !previous;
}
function NotificationBanner({
  title
}) {
  return /* @__PURE__ */ jsx("div", { className: "flex min-h-120 items-center justify-center rounded-md border border-border bg-surface px-16 py-24", role: "alert", children: /* @__PURE__ */ jsx("p", { className: "text-center text-sm leading-base text-text md:text-base", children: title }) });
}
function EmptyPlaceholder({
  message
}) {
  return /* @__PURE__ */ jsx("div", { className: "flex min-h-[86px] items-center justify-start rounded-lg border border-border bg-surface p-20", children: /* @__PURE__ */ jsx("p", { className: "text-base leading-base font-medium text-text", children: message }) });
}
const CONTAINER_CLASSES = "mx-auto w-full max-w-lg px-16 py-24 lg:px-0 lg:py-0";
function CustomerProfileContainer({
  accountNr,
  client,
  countryCode,
  languageCode,
  token,
  onEmptyState
}) {
  const t = useLocalization();
  const {
    trackAction
  } = useDataDogActionTracking();
  useTimeLocale(languageCode);
  const isCircumferenceMappingEnabled = isClientOffline(client);
  const {
    data,
    errors,
    isError,
    isLoading
  } = useCustomerPassportsData({
    accountNr,
    countryCode,
    isCircumferenceMappingEnabled,
    token
  });
  const {
    circumferenceError,
    measurementsError,
    profilesError
  } = errors;
  useEffect(() => {
    const errorEntries = getFailedEndpointDetails({
      errors: {
        circumferenceError,
        measurementsError,
        profilesError
      },
      eventNames: CUSTOMER_PROFILES_FAILURE_EVENTS
    });
    for (const entry of errorEntries) {
      trackAction({
        eventName: entry.eventName,
        eventDetails: {
          accountNr,
          client,
          countryCode,
          errorDetails: entry.errorDetails
        },
        eventType: "error"
      });
    }
  }, [circumferenceError, measurementsError, profilesError, accountNr, client, countryCode, trackAction]);
  const {
    contentClassName,
    phase
  } = useSkeletonPhase(isLoading);
  const customerProfilesList = mapCustomerProfileData({
    circumferencePerProductType: data.circumferencePerProductType,
    isCircumferenceMappingEnabled,
    measurementsPerProductType: data.measurementsPerProductType,
    profilePerProductType: data.profilePerProductType
  });
  const hasNoProfiles = isError || customerProfilesList.length === 0;
  useEffect(() => {
    if (phase === "content") {
      onEmptyState == null ? void 0 : onEmptyState(hasNoProfiles);
    }
  }, [phase, hasNoProfiles, onEmptyState]);
  if (phase !== "content") {
    return /* @__PURE__ */ jsx("div", { "aria-busy": "true", className: `${CONTAINER_CLASSES}${phase === "reserve" ? " invisible" : ""}`, "data-testid": "customer-profiles-skeleton", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-32", children: [
      /* @__PURE__ */ jsx(CustomerProfileCardSkeleton, {}),
      /* @__PURE__ */ jsx(CustomerProfileCardSkeleton, {})
    ] }) });
  }
  if (isError) {
    if (onEmptyState) return null;
    return /* @__PURE__ */ jsx("div", { className: classNames(`${CONTAINER_CLASSES} ${contentClassName}`), children: /* @__PURE__ */ jsx(NotificationBanner, { title: t("shared.profilesOverview.loadListError") }) });
  }
  if (!customerProfilesList.length) {
    if (onEmptyState) return null;
    return /* @__PURE__ */ jsx("div", { className: classNames(`${CONTAINER_CLASSES} ${contentClassName}`), children: /* @__PURE__ */ jsx(EmptyPlaceholder, { message: t("shared.profilesOverview.noPassports") }) });
  }
  return /* @__PURE__ */ jsx("div", { className: classNames(`${CONTAINER_CLASSES} ${contentClassName}`), children: /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-32", children: customerProfilesList.map((item) => /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(CustomerProfileList, { accountNr, circumferenceMeasurementIds: item.circumferenceMeasurementIds, client, countryCode, definitions: item.definitions, productTypeId: item.productTypeId, profile: item.profile, profilesCount: item.profilesCount, title: item.title, token }) }, item.productTypeId)) }) });
}
function LocalizedMissingParametersScreen({
  missingParams
}) {
  const t = useLocalization();
  return /* @__PURE__ */ jsx(MeasMissingParametersScreen, { missingParams, title: t("shared.missingParameters.title") });
}
function HostMonitoring({
  client,
  countryCode,
  hostPlatform
}) {
  useDataDogMonitoringInitializer({
    client,
    countryCode,
    hostPlatform,
    isSimplifiedSession: false,
    isUserIdentifierEnabled: false
  });
  return null;
}
function ProfilesHeader() {
  const t = useLocalization();
  return /* @__PURE__ */ jsx(MeasInfoHeaderTokenized, { customTitle: t("shared.profilesOverview.title") });
}
function MeasCustomerProfilesPublic(t0) {
  "use memo";
  const $ = distExports.c(40);
  const {
    accountNr,
    client,
    countryCode,
    "data-testid": testId,
    env,
    hasHeader: t1,
    hostPlatform,
    languageCode: t2,
    token,
    onEmptyState
  } = t0;
  const hasHeader = t1 === void 0 ? false : t1;
  const languageCode = t2 === void 0 ? DEFAULT_LANGUAGE : t2;
  const appliedClient = client || PassportClients.SuitsupplyRTW;
  let t3;
  if ($[0] !== accountNr || $[1] !== countryCode || $[2] !== token) {
    t3 = getEmptyPropsList({
      accountNr,
      countryCode,
      token
    });
    $[0] = accountNr;
    $[1] = countryCode;
    $[2] = token;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const missingParams = t3;
  if (missingParams.length) {
    let t42;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t42 = [LOCALIZATION_NAMESPACES.SHARED];
      $[4] = t42;
    } else {
      t42 = $[4];
    }
    let t52;
    if ($[5] !== missingParams) {
      t52 = /* @__PURE__ */ jsx(LocalizedMissingParametersScreen, { missingParams });
      $[5] = missingParams;
      $[6] = t52;
    } else {
      t52 = $[6];
    }
    let t62;
    if ($[7] !== languageCode || $[8] !== t52) {
      t62 = /* @__PURE__ */ jsx(LocalizationProvider, { language: languageCode, namespaces: t42, children: t52 });
      $[7] = languageCode;
      $[8] = t52;
      $[9] = t62;
    } else {
      t62 = $[9];
    }
    let t72;
    if ($[10] !== t62 || $[11] !== testId) {
      t72 = /* @__PURE__ */ jsx("div", { className: "meas-public", "data-testid": testId, children: t62 });
      $[10] = t62;
      $[11] = testId;
      $[12] = t72;
    } else {
      t72 = $[12];
    }
    return t72;
  }
  let t4;
  if ($[13] !== appliedClient || $[14] !== countryCode || $[15] !== hostPlatform) {
    t4 = hostPlatform ? /* @__PURE__ */ jsx(HostMonitoring, { client: appliedClient, countryCode, hostPlatform }) : null;
    $[13] = appliedClient;
    $[14] = countryCode;
    $[15] = hostPlatform;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [LOCALIZATION_NAMESPACES.SHARED, LOCALIZATION_NAMESPACES.SIZE_PASSPORT];
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== hasHeader) {
    t6 = hasHeader ? /* @__PURE__ */ jsx(ProfilesHeader, {}) : null;
    $[18] = hasHeader;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== accountNr || $[21] !== appliedClient || $[22] !== countryCode || $[23] !== languageCode || $[24] !== onEmptyState || $[25] !== token) {
    t7 = /* @__PURE__ */ jsx(CustomerProfileContainer, { accountNr, client: appliedClient, countryCode, languageCode, token, onEmptyState });
    $[20] = accountNr;
    $[21] = appliedClient;
    $[22] = countryCode;
    $[23] = languageCode;
    $[24] = onEmptyState;
    $[25] = token;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== t6 || $[28] !== t7) {
    t8 = /* @__PURE__ */ jsxs("div", { className: "min-h-dvh bg-background", children: [
      t6,
      t7
    ] });
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== languageCode || $[31] !== t8) {
    t9 = /* @__PURE__ */ jsx(LocalizationProvider, { language: languageCode, namespaces: t5, children: t8 });
    $[30] = languageCode;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== env || $[34] !== t4 || $[35] !== t9) {
    t10 = /* @__PURE__ */ jsxs(BaseProvider, { env, children: [
      t4,
      t9
    ] });
    $[33] = env;
    $[34] = t4;
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== t10 || $[38] !== testId) {
    t11 = /* @__PURE__ */ jsx("div", { className: "meas-public font-sans w-full", "data-testid": testId, children: t10 });
    $[37] = t10;
    $[38] = testId;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  return t11;
}
export {
  MeasCustomerProfilesPublic as M
};
